module.exports = __webpack_public_path__ + "assets/img/theX-content-5.515ef2db.png";